import { AccountsMsSearchPrivilegesQuery } from "@/api/graphql/accounts/getUserCompanies/queries.ts";
import { getGraphqlClient } from "@/api/graphql/client.ts";
import { AccountsMsSearchPrivilegesRequest } from "@/api/graphql/types/graphql.ts";

export const getUserCompanies = ({
  filters,
  paging,
}: AccountsMsSearchPrivilegesRequest) => {
  const currentPage = paging?.page;
  const pageSize = paging?.size;
  const userId = filters?.userId;
  const filterQuery = filters?.query;

  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(AccountsMsSearchPrivilegesQuery, {
    request: {
      paging: {
        page: currentPage,
        size: pageSize,
      },
      filters: {
        userId: userId,
        query: filterQuery,
      },
    },
  });
};
